import styled from 'styled-components';
import { Select } from '@mui/material';

export const TriggerButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    border-radius: 180px;
    border: 1px solid #b31d15;
    width: auto;
    background-color: transparent;
    color: #b31d15;
    svg {
        font-size: 22px;
        color: #b31d15;
    }
    &:hover {
        background-color: #b31d15;
        color: #fff;
        svg {
            color: #fff;
        }
    }
`;

export const Overlay = styled.div`
    position: fixed;
    inset: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.15);
    z-index: 999;
`;

export const ModalChatContainer = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 95vw;
    max-width: 600px;
    height: 95vh;
    max-height: 600px;
    background: white;
    border-radius: 30px;
    border: 1.5px solid #616161;
    box-shadow: 0 24px 48px rgba(0, 0, 0, 0.18);
    z-index: 1000;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`;

export const InlineChatContainer = styled.div`
    background: white;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-top: 1rem;
`;

export const HeaderActions = styled.div`
    display: flex;
    gap: 4px;
`;

export const ChatHeader = styled.div`
    background: #f0f0f0;
    padding: 12px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: black;
    min-height: 70px;
    box-sizing: border-box;
    p {
        font-size: 18px;
        font-weight: 500;
        color: #000;
        letter-spacing: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 0;
        flex: 1;
        min-width: 0;
    }
    span {
        font-size: 18px;
        font-weight: 700;
    }
`;

export const HeaderInfo = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
    flex: 1;
    min-width: 0;
    overflow: hidden;
`;

export const CustomSelect = styled(Select)`
    border-radius: 80px;
    background: #b31d15;
    color: #fff;
    font-size: 16px;
    height: 30px;
`;

export const LoadingContainer = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const EmptyChatMessage = styled.div`
    display: flex;
    padding: 24px;
    text-align: center;
    height: 100%;
    justify-content: center;
    align-items: flex-start;
`;
